;(function (window) {
  var url = window.location.href.toString();
  var isUserOnSignupPage = url.includes('/try-geckoboard');

  if(!isUserOnSignupPage) {
    var hasVisitedFirstTime = readCookie('first_touch_url_params');

    if(!hasVisitedFirstTime) {
      var urlParams = new URLSearchParams(window.location.search);

      var firstTouchUrlParams = {
        url: window.location.href,
        date: new Date(),
        referrer: urlParams.get('referrer'),
        utm_source: urlParams.get('utm_source'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_term: urlParams.get('utm_term'),
        utm_content: urlParams.get('utm_content'),
      }
  
      // To store the first touch object in the cookie we need to stringify it first
      var stringifiedFirstTouchUrlParams = JSON.stringify(firstTouchUrlParams);
      // Our App uses ruby on rails which requires us to encode the stringified object so it can read the first touch object
      var encodedFirstTouchUrlParams = encodeURIComponent(stringifiedFirstTouchUrlParams);
  
      createCookie('first_touch_url_params', encodedFirstTouchUrlParams, 30);
    }

    createCookie('last_touch_url', window.location.href, 30);
  }
})(window)